import _ from 'lodash';

export const sortByRelevance = <T>(
    items: T[],
    searchText: string,
    getLabel: (item: T) => string,
): T[] => {
    const normalizedSearch = searchText.toLowerCase();

    return _(items)
        .filter((item) => getLabel(item).toLowerCase().includes(normalizedSearch))
        .orderBy(
            [
                (item) => getLabel(item).toLowerCase().startsWith(normalizedSearch),
                (item) => getLabel(item).toLowerCase().indexOf(normalizedSearch),
            ],
            ['desc', 'asc'],
        )
        .value();
};
